import { render, staticRenderFns } from "./UsersTableNonOwner.vue?vue&type=template&id=db795386&"
import script from "./UsersTableNonOwner.vue?vue&type=script&lang=js&"
export * from "./UsersTableNonOwner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports